import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-ic_skip_next_black",
  "use": "tamr-icon-ic_skip_next_black-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"tamr-icon-ic_skip_next_black\"><path d=\"M3.42,20.58,15.58,12,3.42,3.42ZM17.72,3.42V20.58h2.86V3.42Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol